function LeagueTableRow({ row }) {
  return (
    <>
      {/* Mobile: Card layout */}
      <div className="md:hidden rounded-2xl bg-white p-4 shadow-sm ring-1 ring-slate-200">
        <div className="flex items-start justify-between gap-3 mb-3">
          <div>
            <p className="text-sm font-semibold text-slate-900">{row.displayName}</p>
            <p className="text-xs text-slate-500">League member</p>
          </div>
          <div className="shrink-0 rounded-full bg-slate-100 px-3 py-1">
            <p className="text-sm font-bold text-slate-700">#{row.position}</p>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-3">
          <div className="rounded-xl bg-slate-50 p-3 text-center">
            <p className="text-lg font-bold tracking-tight text-slate-900">{row.totalPoints}</p>
            <p className="text-xs text-slate-500 mt-1">pts</p>
          </div>
          <div className="rounded-xl bg-slate-50 p-3 text-center">
            <p className="text-sm font-semibold text-slate-900">{row.exactScores}</p>
            <p className="text-xs text-slate-500 mt-1">exact</p>
          </div>
          <div className="rounded-xl bg-slate-50 p-3 text-center">
            <p className="text-sm font-semibold text-slate-900">{row.correctResults}</p>
            <p className="text-xs text-slate-500 mt-1">correct</p>
          </div>
        </div>
      </div>

      {/* Desktop: Grid layout */}
      <div className="hidden md:grid grid-cols-[56px_1fr_88px_88px_110px] items-center gap-4 rounded-2xl bg-white px-4 py-4 shadow-sm ring-1 ring-slate-200">
        <div className="text-sm font-bold text-slate-500">#{row.position}</div>
        <div>
          <p className="text-sm font-semibold text-slate-900">{row.displayName}</p>
          <p className="mt-1 text-xs text-slate-500">League member</p>
        </div>
        <div className="text-right">
          <p className="text-lg font-bold tracking-tight text-slate-900">{row.totalPoints}</p>
          <p className="text-xs text-slate-500">pts</p>
        </div>
        <div className="text-right">
          <p className="text-sm font-semibold text-slate-900">{row.exactScores}</p>
          <p className="text-xs text-slate-500">exact</p>
        </div>
        <div className="text-right">
          <p className="text-sm font-semibold text-slate-900">{row.correctResults}</p>
          <p className="text-xs text-slate-500">correct</p>
        </div>
      </div>
    </>
  );
}

export default LeagueTableRow;
